<div>
  <app-page>
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="onBackClick()"
      ></dx-button>

      <dx-button
        [text]="'COMMON.COMPLETE' | translate"
        (click)="onCompleteClick()"
        [disabled]="!isAllPersonsValid || !isAttachmentValid || isFormSubmitting"
      ></dx-button>
    </div>
    <app-page-title
      [title]="'TRAINING.COMPLETE.SELECT-ATTENDEES' | translate"
    ></app-page-title>
    <app-panel [title]="'TRAINING.COMPLETE.ATTENDEES-LIST' | translate">
      <ng-container *ngIf="allEventMembersWithESignature !== undefined">
        @if(!allEventMembersWithESignature || isOnlineMeetingType) {
          <dx-form #form [formData]="formData" labelLocation="top">
            <dxi-item>
              <dxo-label [visible]="false"></dxo-label>
              <div *dxTemplate class="file-uploader-wrapper">
                <dx-file-uploader
                  [visible]="false"
                  dialogTrigger="#fileTrigger"
                  [accept]="acceptedFileTypes"
                  [multiple]="false"
                  uploadMode="useForm"
                  [showFileList]="true"
                  (valueChange)="onMemberListSelected($event)"
                >
                </dx-file-uploader>
                <dx-button
                  id="fileTrigger"
                  [text]="'COMMON.SELECT-FILE' | translate"
                  type="default"
                  class="integration-btn"
                ></dx-button>
                <span *ngIf="!formData.memberList && isAttachmentMandatory" class="no-file-text">
                  {{'TRAINING.COMPLETE.UPLOAD-ATTENDANCE-LIST-INFO'| translate}}
                </span>
                <span
                  *ngIf="!formData.memberList && !isAttachmentMandatory"
                  class="no-file-text"
                >
                  {{
                    (allEventMembersWithESignature
                      ? 'TRAINING.COMPLETE.UPLOAD-ATTENDANCE-LIST-INFO-OPTIONAL-FOR-ESIGNATURE'
                      : 'TRAINING.COMPLETE.UPLOAD-ATTENDANCE-LIST-INFO-OPTIONAL'
                    ) | translate
                  }}
                </span>
                <span class="file-name" *ngIf="formData.memberList">
                  {{ formData.memberList.name }}
                </span>
              </div>
            </dxi-item>
          </dx-form>
        } @else {
          <div>
            <span class="no-file-text"> 
              {{ 'TRAINING.COMPLETE.ALL-PARTICIPANTS-CONFIMED-THEIR-ATTENDANCE' | translate }}
            </span>
            <br><br>
          </div>
        }
      </ng-container>
      <app-attendee-list #attendeeList [trainingId]="trainingId"></app-attendee-list>
    </app-panel>
    <app-panel 
      *ngIf="isSuperAdmin"
      [title]="'TRAINING.COMPLETE.MEETING-FILES.TITLE' | translate"
    >
      <div class="upload-files-text">
        {{ 'TRAINING.COMPLETE.MEETING-FILES.TEXT' | translate }}
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-5">
          <app-panel class="document-panel">
            <div id="document-upload" class="uploader-container">
              <div class="uploader-preview-container">
                <img src="assets/img/upload.jpg" />
                <span class="preview-title">{{
                  "COMMON.UPLOAD-DOCUMENT" | translate
                }}</span>
              </div>
            </div>
            <dx-file-uploader
              #fileUploader
              dialogTrigger="#document-upload"
              dropZone="#document-upload"
              [multiple]="true"
              uploadMode="useForm"
              [visible]="false"
              (valueChange)="onDocumentSelected($event)"
            ></dx-file-uploader>
          </app-panel>
        </div>
        <div class="col-md-12 col-lg-7">
          <app-panel class="files-panel">
            <div class="files-title">
              {{ "COMMON.FILES" | translate }} ({{ formData.meetingFiles.length }})
            </div>
            <div class="full-height-list">
              <div class="list-wrapper">
                <dx-list
                  [dataSource]="formData.meetingFiles"
                  class="striped-list"
                >
                  <div *dxTemplate="let item of 'item'; let i = index">
                    <div class="file">
                      <div class="file-name">
                        {{ item.name }}
                      </div>
                      <div
                        class="close-action"
                        (click)="onRemoveDocument(i)"
                      >
                        <i class="dx-icon-close"></i>
                      </div>
                    </div>
                  </div>
                </dx-list>
              </div>
            </div>
          </app-panel>
        </div>
      </div>
    </app-panel>
  </app-page>
</div>

<app-confirmation-dialog
  [height]="'auto'"
  [showModal]="showUnsavedIddTimeChangesModal"
  (showModalChange)="onShowUnsavedIddTimeChangesModalChanged($event)"
  (submit)="saveIddTimeChanges()"
  [options]="unsavedIddTimeChangesModalOptions"
></app-confirmation-dialog>